import { createAsyncThunk } from "@reduxjs/toolkit"
import { postRequest } from "../../common/services/httpMethod/httpMethod"
import { api } from "../../common/services/api/api"

export const lodgeShipmentRequest = createAsyncThunk(
  "lodge/shipment",
  async (values, { rejectWithValue }) => {
    try {
      const dateObj = new Date()
      const month = dateObj.getUTCMonth() + 1 // months from 1-12
      const day = dateObj.getUTCDate()
      const year = dateObj.getUTCFullYear()
      const pMonth = month.toString().padStart(2, "0")
      const pDay = day.toString().padStart(2, "0")

      const data = {
        shipment_type: "international",
        shipment_item_worth: "0",
        shipping_quantity: "0",
        height: "0",
        width: "0",
        isFragile: "0",
        isLiquid: "0",
        sender_name: values.sender_name,
        sender_email: values.sender_email,
        // sender_address: `${values.sender_country}-${values.sender_airport}`,
        sender_address: values.sender_airport,
        weight: values.weight,
        // receiver_country: `${values.receiver_country}-${values.receiver_airport}`,
        receiver_country: values.receiver_airport,
        receiver_name: values.receiver_name,
        receiver_email: values.receiver_email,
        receiver_address: "-",
        receiver_phone: "-",
        shipment_description: values.description,
        drop_off_date: `${year}-${pMonth}-${pDay}`,
      }
      const response = await postRequest(api.lodgeShipmentCreate, data)
      return response?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)
